import Link from "next/link";
import React from "react";

const ReservationForm = () => {
  return (
    <section className="p-7.5 xl:p-20 rounded-b-[40px] xl:rounded-b-[150px] border-b border-b-white bg-[url('/imgs/contact-bg.png')] bg-cover bg-center bg-no-repeat relative">
      <div className="w-full grid grid-cols-1 xl:grid-cols-[1fr_1fr] 2xl:grid-cols-[756px_1fr] gap-7.5 p-8 2xl:px-[66px] 2xl:py-[70px] bg-white/1 rounded-[23px] lg:rounded-[50px] backdrop-blur-[15px] border border-white/[57%]">
        <div className="xl:block hidden h-full w-full bg-[url('/imgs/contact-form.png')] bg-cover bg-center bg-no-repeat rounded-[15px] overflow-hidden"></div>
        <div className="center flex-col justify-start">
          <h1 className="text-[35.83px] sm:text-[75px] leading-[86%] font-bold font-amiri text-old-lace">
            <Link href="/coming-soon"> Book a Table</Link>
          </h1>
          <p className="text-[9.56px] sm:text-xl leading-[127%] font-medium text-center my-2 sm:my-5 text-old-lace">
            Secure your spot today and enjoy delicious food and a welcoming
            atmosphere for a perfect dining experience!
          </p>

          <form action="" className="w-full mt-6 space-y-[5px]">
            <div className="">
              <label htmlFor="name" className="input_label">
                Name
              </label>
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Enter your name"
                className="input"
              />
            </div>
            <div className="">
              <label htmlFor="email" className="input_label">
                Email
              </label>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Enter your email"
                className="input"
              />
            </div>
            <div className="">
              <label htmlFor="people" className="input_label">
                People
              </label>
              <input
                type="number"
                name="people"
                id="people"
                placeholder="Enter your name"
                className="input"
              />
            </div>
            <div className="flex flex-col lg:flex-row w-full gap-5">
              <div className="w-full">
                <label htmlFor="date" className="input_label">
                  Date
                </label>
                <input
                  type="date"
                  name="date"
                  id="date"
                  placeholder="dd - mm - yyyy"
                  className="input"
                />
              </div>
              <div className="w-full">
                <label htmlFor="time" className="input_label">
                  Time
                </label>
                <input
                  type="time"
                  name="time"
                  id="time"
                  placeholder=""
                  className="input"
                />
              </div>
            </div>
            <div>
               <Link
                href="https://wa.me/8801830000233"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full h-[34.4px] sm:h-[72px] bg-old-gold text-[#1B1B1B] mt-[22px] sm:mt-[45px] text-[8.6px] sm:text-lg font-bold rounded-[6px] border border-white flex items-center justify-center"
              >
                Make Reservation
              </Link>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ReservationForm;
